import { ChatChannel, ChatChannelInterface } from "./ChatChannel";

interface ChatChannelUserInterface extends ChatChannelInterface {
    merchant: boolean;
    banned: boolean;
}

export class ChatChannelUser extends ChatChannel implements ChatChannelUserInterface {
    merchant: boolean;
    banned: boolean;

    constructor(data: ChatChannelUserInterface) {
        super(data);
        this.merchant = data.merchant;
        this.banned = data.banned;
    }
}